import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1328b69d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TablePagination" }
const _hoisted_2 = { class: "TablePagination__block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_pagination, {
        totalPages: _ctx.totalPages,
        currentPage: _ctx.currentPage,
        onChange: _ctx.emitChange
      }, null, 8, ["totalPages", "currentPage", "onChange"])
    ])
  ]))
}